import React, { useState, useEffect } from "react";
import axios from "axios";
import "./WhatsAppPage.css";

const WhatsAppPage = () => {
    const [number, setNumber] = useState("");
    const [message, setMessage] = useState("");
    const [file, setFile] = useState(null);
    const [qrCode, setQrCode] = useState("");
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        fetchQrCode();
    }, []);

    const fetchQrCode = async () => {
        try {
            const response = await axios.get("https://leadbankapi.gensparc.com/api/whatsapp/qrcode", {
                responseType: "json",
            });
    
            if (response.data.loggedIn) {
                setIsLoggedIn(true);
            } else {
                setQrCode(response.data.qrCode);
                setIsLoggedIn(false);
            }
        } catch (error) {
            console.error("Error fetching QR code:", error);
        }
    };
    const sendMessage = async () => {
        try {
            const response = await axios.post("https://leadbankapi.gensparc.com/api/whatsapp/send-message", { number, message });
            alert(response.data.message);
        } catch (error) {
            console.error("Error sending message:", error);
            alert("Failed to send message.");
        }
    };

    const sendBulkMessages = async () => {
        if (!file) {
            alert("Please upload an Excel file");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await axios.post("https://leadbankapi.gensparc.com/api/whatsapp/send-bulk", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            alert(response.data.message);
        } catch (error) {
            console.error("Error sending bulk messages:", error);
            alert("Failed to send bulk messages.");
        }
    };

    return (
        <div className="whatsapp-container">
            <h1>WhatsApp Messaging</h1>

         {/* QR Code Section */}
<div className="qr-section">
    {isLoggedIn ? (
        <p style={{ color: "green", fontWeight: "bold" }}>✅ You are already logged in!</p>
    ) : qrCode ? (
        <img src={qrCode} alt="QR Code" style={{ width: "300px", height: "300px" }} />
    ) : (
        <p>Loading QR Code...</p>
    )}
</div>

            {/* Single Message Section */}
            <div className="input-group">
                <input
                    type="text"
                    placeholder="Enter Number"
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                />
                <textarea
                    placeholder="Enter Message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
                <button onClick={sendMessage}>Send Message</button>
            </div>

            {/* Bulk Messaging Section */}
            <div className="bulk-upload">
                <h2>Bulk Messaging</h2>
                <input type="file" accept=".xlsx, .xls" onChange={(e) => setFile(e.target.files[0])} />
                <button onClick={sendBulkMessages}>Send</button>
            </div>
        </div>
    );
};

export default WhatsAppPage;
